import { render } from "./App.vue?vue&type=template&id=1ac22bde"
const script = {}

import exportComponent from "Z:\\advance_Project\\SOD_BavloWeb3D_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__